<!-- Holi Theme Particles -->
@if (isHoliActive) {
  <app-holi-particles></app-holi-particles>
}

<!-- Fixed Header with blur effect (Netflix + Hotstar style) -->
<header class="header" [class.scrolled]="isScrolled">
  <div class="header-left">
    <img
      [src]="
        isHoliActive
          ? 'assets/images/abc-logo-holi.svg'
          : 'https://abctalkies.com/assets/images/abc-logo.svg'
      "
      alt="ABC Talkies"
      class="logo"
      [class.valentine-logo]="isValentineActive"
      routerLink="/"
    />
    <!-- Desktop Nav -->
    <nav class="nav desktop-nav">
      <!-- Viewer Menu Hidden as per User Request -->
      <!-- @if (isLoggedIn) {
      <a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a routerLink="/tv-shows" class="nav-link" routerLinkActive="active">TV Shows</a>
      <a routerLink="/movies" class="nav-link" routerLinkActive="active">Movies</a>
      <a routerLink="/new-popular" class="nav-link" routerLinkActive="active">New & Popular</a>
      <a routerLink="/my-list" class="nav-link" routerLinkActive="active">My List</a>
      } @else { -->
      <a href="https://abcfilmfactory.com/" class="nav-link" target="_blank"
        >I'm a Filmmaker</a
      >
      <!-- } -->
    </nav>
  </div>

  <div class="header-right">
    <!-- Wallet & Coins (Desktop) - MOVED BEFORE SEARCH AS REQUESTED -->
    @if (isLoggedIn) {
      <div class="wallet-stats">
        <!-- Wallet Balance -->
        <div
          class="wallet-item"
          [routerLink]="['/app/profile/viewer']"
          [queryParams]="{ activeTab: 3 }"
          title="Wallet Balance"
        >
          <div class="stat-icon-wrapper">
            <!-- Rupee Symbol -->
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M13.66 7C13.1 5.82 11.9 5 10.5 5H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"
              />
            </svg>
          </div>
          <!-- Fix: Show decimals if present, up to 2 places. Matches '7.5' -->
          <span class="stat-value">{{ walletBalance | number: "1.0-2" }}</span>
        </div>

        <!-- Coins -->
        <div
          class="wallet-item coins"
          [routerLink]="['/app/profile/viewer']"
          [queryParams]="{ activeTab: 3 }"
          title="ABC Coins"
        >
          <div class="stat-icon-wrapper">
            <!-- Coins Stack Symbol -->
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 3c-4.42 0-8 1.79-8 4s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v4c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 6v4c0 2.21 3.58 4 8 4s8-1.79 8-4v-4c0 2.21-3.58 4-8 4s-8-1.79-8-4z"
              />
            </svg>
          </div>
          <span class="stat-value">{{ coinBalance }}</span>
        </div>
      </div>
    }

    <!-- PWA Install Button (Visible when installable) -->
    @if (pwaService.isInstallable$ | async) {
      <button
        class="icon-btn install-btn"
        aria-label="Install App"
        title="Install App"
        (click)="installPwa()"
        appTvFocusable
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
        </svg>
      </button>
    }

    <!-- Search Button (Toggles Overlay) - Visible to ALL (Guest & User) per static file -->
    <button
      class="icon-btn search-btn"
      aria-label="Search"
      (click)="openAbcSearch()"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        />
      </svg>
    </button>

    @if (isLoggedIn) {
      <!-- Notifications -->
      <div class="nav-item-wrapper" (clickOutside)="closeNotification($event)">
        <button
          class="icon-btn notif-btn"
          id="abc-notification"
          aria-label="Notifications"
          (click)="openNotification(); $event.stopPropagation()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
            />
          </svg>
          @if (isNotificationPush) {
            <span class="badge-dot"></span>
          }
        </button>

        <!-- Notification Dropdown (Desktop Only) -->
        @if (!isMobile) {
          <div
            class="abc-notification-dropdown"
            [class.active]="isNotification"
            (click)="$event.stopPropagation()"
          >
            <div class="dropdown-header">
              <h3>{{ "nav.Notifications" | translate }}</h3>
              <button class="mark-read-btn" (click)="markAllRead()">
                {{ "nav.MarkAllRead" | translate }}
              </button>
            </div>
            <div class="dropdown-content">
              @if (notificationList.length > 0) {
                @for (item of notificationList; track item._id) {
                  <div
                    class="notif-item"
                    [class.unread]="!item.read"
                    (click)="onRedirect(item)"
                  >
                    <div class="notif-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                        />
                      </svg>
                    </div>
                    <div class="notif-info">
                      <p class="notif-title">{{ item.title }}</p>
                      <p class="notif-desc">{{ item.message }}</p>
                      <span class="notif-time">{{
                        item.createdAt | date: "short"
                      }}</span>
                    </div>
                  </div>
                }
              } @else {
                <div class="empty-state">
                  <p>{{ "nav.NoNewNotifications" | translate }}</p>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Rewards Button (Gift) -->
      <button
        class="icon-btn rewards-btn"
        aria-label="Rewards"
        (click)="openRewards()"
      >
        <!-- Gift Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
          />
        </svg>
      </button>

      <!-- Language Button (Translate) -->
      <div
        class="nav-item-wrapper language-wrapper"
        (clickOutside)="closeLanguage()"
      >
        <button
          class="icon-btn lang-btn"
          [class.active]="isLanguageOpen"
          aria-label="Language"
          (click)="toggleLanguage(); $event.stopPropagation()"
        >
          <!-- Translate Icon -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
            />
          </svg>
        </button>

        <!-- Language Dropdown -->
        <div
          class="abc-language-dropdown"
          [class.active]="isLanguageOpen"
          (click)="$event.stopPropagation()"
        >
          <div class="lang-header">
            <span>{{ getLanguageName(selectedLanguage) }}</span>
          </div>
          <div class="lang-list">
            @for (lang of languageList; track lang.code) {
              @if (lang.code !== selectedLanguage) {
                <div class="lang-item" (click)="selectLanguage(lang.code)">
                  {{ lang.name }}
                </div>
              }
            }
          </div>
        </div>
      </div>

      <!-- Profile Dropdown (Custom to match design) -->
      <div
        class="nav-item-wrapper profile-wrapper"
        (clickOutside)="closeProfile()"
      >
        <div
          class="profile-menu"
          (click)="toggleProfile(); $event.stopPropagation()"
        >
          <img [src]="profileImage" alt="Profile" class="avatar" />
          <span class="dropdown-arrow" [class.open]="isProfile">▼</span>
        </div>

        <div
          class="abc-profile-dropdown"
          [class.active]="isProfile"
          (click)="$event.stopPropagation()"
        >
          <div class="profile-header">
            <img [src]="profileImage" alt="Profile" class="header-avatar" />
            <div class="profile-info">
              <span class="profile-name">{{ displayPrimary }}</span>
              <span class="profile-email" *ngIf="displaySecondary">{{
                displaySecondary
              }}</span>
            </div>
          </div>
          <div class="profile-links">
            <a
              [routerLink]="['/app/profile/viewer']"
              [queryParams]="{ activeTab: 1 }"
              class="profile-link"
              (click)="closeProfile()"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                />
              </svg>
              {{ "nav.Profile" | translate }}
            </a>
            <!-- Added missing items as per request -->
            @if (checkForRoles()) {
              <a
                (click)="switchRole('FILM_MAKER'); closeProfile()"
                class="profile-link"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
                  />
                </svg>
                Switch To Film Maker
              </a>
            }
            <a
              (click)="openReferralDialog(shareReferral); closeProfile()"
              class="profile-link"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                />
              </svg>
              Refer & Earn
            </a>

            <div class="divider"></div>
            <a (click)="onClickLogout()" class="profile-link logout">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                />
              </svg>
              {{ "nav.Logout" | translate }}
            </a>
          </div>
        </div>
      </div>
    } @else {
      <!-- Guest: Profile Icon links to Login -->
      <button class="icon-btn" routerLink="/sign-in">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          />
        </svg>
      </button>
    }

    <!-- Mobile Hamburger -->
    <button
      class="hamburger"
      [class.active]="isMobileMenuOpen"
      (click)="toggleMobileMenu()"
      aria-label="Menu"
    >
      <span></span><span></span><span></span>
    </button>
  </div>
</header>

<!-- Mobile Navigation Drawer -->
<div class="mobile-nav" [class.active]="isMobileMenuOpen">
  @if (isLoggedIn) {
    <!-- Aligned with Desktop: Viewer items hidden as per request -->
    <!-- <a routerLink="/" class="mobile-nav-link" (click)="closeMobileMenu()">Home</a> -->

    <a
      href="https://abcfilmfactory.com/"
      class="mobile-nav-link"
      target="_blank"
      >I'm a Filmmaker</a
    >
    <a
      [routerLink]="['/app/profile/viewer']"
      [queryParams]="{ activeTab: 1 }"
      class="mobile-nav-link"
      (click)="closeMobileMenu()"
      >{{ "nav.Profile" | translate }}</a
    >

    @if (checkForRoles()) {
      <a
        (click)="switchRole('FILM_MAKER'); closeMobileMenu()"
        class="mobile-nav-link"
        >Switch To Film Maker</a
      >
    }

    <a
      (click)="openReferralDialog(shareReferral); closeMobileMenu()"
      class="mobile-nav-link"
      >Refer & Earn</a
    >
    <a (click)="onClickLogout()" class="mobile-nav-link logout">{{
      "nav.Logout" | translate
    }}</a>
  } @else {
    <a
      href="https://abcfilmfactory.com/"
      class="mobile-nav-link"
      target="_blank"
      >I'm a Filmmaker</a
    >
    <a routerLink="/sign-in" class="mobile-nav-link">Login</a>
  }
</div>

<!-- Search Overlay - Netflix Style -->
<div class="search-overlay" [class.active]="isSearchOpen">
  <div class="search-container">
    <div class="search-header">
      <div class="search-input-wrapper">
        <svg
          class="search-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
        <input
          #searchInput
          id="abc-search-input"
          type="text"
          [formControl]="queryField"
          class="search-input"
          placeholder="Search movies, series, genres..."
          autocomplete="off"
        />
        <button
          class="search-clear"
          [class.visible]="searchInput.value.length > 0"
          (click)="searchInput.value = ''; queryField.setValue('')"
          aria-label="Clear search"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>
      <button
        class="search-close"
        (click)="closeAbcSearch()"
        aria-label="Close search"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </button>
    </div>

    <div class="search-results">
      <!-- Loading State -->
      @if (isLoading) {
        <div class="search-loading">
          <div class="search-spinner"></div>
          <p>Searching...</p>
        </div>
      }

      <!-- Empty State (No Input) -->
      @if (
        !isLoading &&
        !isMatches &&
        (!queryField.value || queryField.value.trim().length === 0)
      ) {
        <div class="search-empty">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="currentColor"
            opacity="0.3"
          >
            <path
              d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
            />
          </svg>
          <p>Type to search</p>
        </div>
      }

      <!-- No Results Found -->
      @if (
        !isLoading &&
        !isMatches &&
        queryField.value &&
        queryField.value.trim().length > 0
      ) {
        <div class="search-empty">
          <p>No results found for "{{ queryField.value }}"</p>
        </div>
      }
      <!-- Results Grid -->
      @if (!isLoading && isMatches) {
        <div class="search-results-content">
          <div class="search-grid">
            <!-- Language Result -->
            @if (matches?.language) {
              <div
                class="card portrait special-card"
                [routerLink]="['/view-film-list/language']"
                [queryParams]="{ id: matches?.language?._id }"
                (click)="closeAbcSearch()"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      matches?.language?.languageUrl ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ matches?.language?.name }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">
                        {{ matches?.language?.name }}
                      </div>
                      <div class="card-badge language-badge">Language</div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Genre Result -->
            @if (matches?.genre) {
              <div
                class="card portrait"
                [routerLink]="['/view-film-list/genre']"
                [queryParams]="{ id: matches?.genre?._id }"
                (click)="closeAbcSearch()"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      matches?.genre?.genreUrl ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ matches?.genre?.name }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">{{ matches?.genre?.name }}</div>
                      <div class="card-badge genre-badge">Genre</div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Filmmaker Result -->
            @if (matches?.filmMaker) {
              <div
                class="card portrait"
                [routerLink]="['/filmmaker-detail', matches?.filmMaker?._id]"
                (click)="closeAbcSearch()"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      matches?.filmMaker?.logoUrl ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ matches?.filmMaker?.productionHouse }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">
                        {{ matches?.filmMaker?.productionHouse }}
                      </div>
                      <div class="card-badge filmmaker-badge">Filmmaker</div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Movies -->
            @for (film of matches?.films; track film._id) {
              <div
                class="card portrait"
                (click)="closeAbcSearch('FILM', film._id)"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      film.largePortrait ||
                      film.portrait ||
                      film.banner ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ film.title }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">{{ film.title }}</div>
                      <div class="card-meta-line">
                        {{ film.releaseDate | date: "yyyy" }}
                      </div>
                      @if (!film.isFreeWatch) {
                        @if (film.price && film.price.totalPrice != 0) {
                          <div class="card-price">
                            {{ film.price.currencySymbol }}
                            {{ film.price.totalPrice }}
                          </div>
                        } @else {
                          <div><span class="abc-free-badge">Free</span></div>
                        }
                      } @else {
                        <div><span class="abc-free-badge">Free</span></div>
                      }
                      <div class="card-badge movie-badge">Movie</div>
                    </div>
                    <div class="card-actions">
                      <button class="card-btn">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Web Series -->
            @for (series of matches?.webSeries; track series._id) {
              <div
                class="card portrait"
                (click)="closeAbcSearch('WEB_SERIES', series._id)"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      series.largePortrait ||
                      series.portrait ||
                      series.banner ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ series.title }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">{{ series.title }}</div>
                      <div class="card-meta-line">
                        {{ series.releaseDate | date: "yyyy" }}
                      </div>
                      @if (!series.isFreeWatch) {
                        @if (series.price && series.price.totalPrice != 0) {
                          <div class="card-price">
                            {{ series.price.currencySymbol }}
                            {{ series.price.totalPrice }}
                          </div>
                        } @else {
                          <div><span class="abc-free-badge">Free</span></div>
                        }
                      } @else {
                        <div><span class="abc-free-badge">Free</span></div>
                      }
                      <div class="card-badge series-badge">Series</div>
                    </div>
                    <div class="card-actions">
                      <button class="card-btn">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Micro Series -->
            @for (micro of matches?.microSeries; track micro._id) {
              <div
                class="card portrait"
                (click)="closeAbcSearch('MICRO_SERIES', micro._id)"
              >
                <div class="card-inner">
                  <img
                    [src]="
                      micro.largePortrait ||
                      micro.portrait ||
                      micro.banner ||
                      'https://images.abctalkies.in/assets/images/abc-blank-upload-image.jpg'
                    "
                    class="card-img"
                    alt="{{ micro.title }}"
                    loading="lazy"
                  />
                  <div class="card-overlay">
                    <div class="card-meta-info">
                      <div class="card-title">{{ micro.title }}</div>
                      <div class="card-meta-line">Micro Series</div>
                      @if (!micro.isFreeWatch) {
                        @if (micro.price && micro.price.totalPrice != 0) {
                          <div class="card-price">
                            {{ micro.price.currencySymbol }}
                            {{ micro.price.totalPrice }}
                          </div>
                        } @else {
                          <div><span class="abc-free-badge">Free</span></div>
                        }
                      } @else {
                        <div><span class="abc-free-badge">Free</span></div>
                      }
                      <div class="card-badge microseries-badge">Shorts</div>
                    </div>
                    <div class="card-actions">
                      <button class="card-btn">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Mobile Bottom Navigation (V2) -->
<nav class="mobile-bottom-nav">
  <a
    routerLink="/"
    class="nav-item"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
    <span>{{ "nav.Home" | translate }}</span>
  </a>
  <a (click)="openAbcSearch()" class="nav-item">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </svg>
    <span>{{ "nav.Search" | translate }}</span>
  </a>

  @if (isLoggedIn) {
    <!-- Rewards Tab (Moved from top to tab bar as request) -->
    <a (click)="openRewards()" class="nav-item" aria-label="Rewards">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
        />
      </svg>
      <span>{{ "vp.Rewards" | translate }}</span>
    </a>
  }

  <!-- Guest: No Login Tab (Use Menu > Login) - Only 3 Tabs (Home, Search, Menu) -->

  <div
    class="nav-item"
    (click)="toggleMobileMenu()"
    [class.active]="isMobileMenuOpen"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
      />
    </svg>
    <span>{{ "nav.Menu" | translate }}</span>
  </div>
</nav>

<ng-template #shareReferral>
  <app-share-referral (closeModals)="closeReferralDialog()" />
</ng-template>

<!-- Language Selection Modal -->
<div
  class="language-modal-overlay"
  [class.active]="isLanguageOpen"
  (click)="closeLanguage()"
>
  <div class="language-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      @if (isNewUser) {
        <h3>{{ "nav.WelcomeSelectLanguage" | translate }}</h3>
        <p>{{ "nav.CustomizeExperience" | translate }}</p>
      } @else {
        <h3>{{ "nav.SelectLanguage" | translate }}</h3>
      }
      <button class="close-btn" (click)="closeLanguage()">×</button>
    </div>
    <div class="language-grid">
      @for (lang of languageList; track lang.code) {
        <button
          class="lang-option"
          [class.selected]="selectedLanguage === lang.code"
          (click)="selectLanguage(lang.code)"
        >
          <span class="lang-name">{{ lang.name }}</span>
          @if (selectedLanguage === lang.code) {
            <span class="check-icon">✓</span>
          }
        </button>
      }
    </div>
    <div class="modal-actions">
      <button class="abc-btn-primary" (click)="saveLanguage()">
        {{ "nav.SavePreference" | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Mobile Notification Bottom Sheet -->
@if (isMobile) {
  <div
    class="mobile-notification-overlay"
    [class.active]="isNotification"
    (click)="closeNotification($event)"
  ></div>
  <div
    class="abc-notification-dropdown mobile-sheet"
    [class.active]="isNotification"
    (click)="$event.stopPropagation()"
  >
    <div class="dropdown-header">
      <h3>{{ "nav.Notifications" | translate }}</h3>
      <button class="mark-read-btn" (click)="markAllRead()">
        {{ "nav.MarkAllRead" | translate }}
      </button>
    </div>
    <div class="dropdown-content">
      @if (notificationList.length > 0) {
        @for (item of notificationList; track item._id) {
          <div
            class="notif-item"
            [class.unread]="!item.read"
            (click)="onRedirect(item)"
          >
            <div class="notif-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                />
              </svg>
            </div>
            <div class="notif-info">
              <p class="notif-title">{{ item.title }}</p>
              <p class="notif-desc">{{ item.message }}</p>
              <span class="notif-time">{{
                item.createdAt | date: "short"
              }}</span>
            </div>
          </div>
        }
      } @else {
        <div class="empty-state">
          <p>{{ "nav.NoNewNotifications" | translate }}</p>
        </div>
      }
    </div>
  </div>
}
